import { cva } from "class-variance-authority"

import { cn } from "../../helpers"
import { body } from "../typography"

const radioCardVariants = cva(
  "flex items-center ring-1 text-black ring-neutral-200 p-4 cursor-pointer rounded-2xl hover:ring-neutral-300 hover:ring-2 hover:shadow-neutral-below-large transition-colors",
  {
    variants: {
      checked: {
        false: "",
        true: "",
      },
      disabled: {
        false: "",
        true: "opacity-50 cursor-not-allowed ring-1 ring-neutral-200 hover:ring-1 hover:ring-neutral-200 focus-within:ring-0 hover:ring-offset-0 focus-within:ring-offset-0 bg-neutral-50",
      },
    },
  }
)

const radioCardCheckableVariants = cva(
  "flex items-center ring-1 text-black ring-neutral-200 p-4 cursor-pointer rounded-2xl hover:ring-neutral-300 hover:ring-2 hover:shadow-neutral-below-large transition-colors",
  {
    variants: {
      checked: {
        false: "",
        true: "ring-blurple-500 ring-2 hover:ring-blurple-500 hover:shadow-none",
      },
      disabled: {
        false: "",
        true: "opacity-50 cursor-not-allowed ring-1 ring-neutral-200 hover:ring-1 hover:ring-neutral-200 focus-within:ring-0 hover:ring-offset-0 focus-within:ring-offset-0 bg-neutral-50",
      },
    },
  }
)

const indicatorVariants = cva(
  "group w-5 h-5 rounded-full flex justify-center items-center flex-shrink-0",
  {
    variants: {
      checked: {
        false: "border-2 border-[#C9C4C9]",
        true: "bg-blurple-500",
      },
      disabled: {
        false: "",
        true: "bg-white border-2 border-neutral-600",
      },
    },
  }
)

const root = cn("flex w-full items-center justify-between")
const wrapper = cn("flex items-center gap-4")
const label = body({ size: "md" })
const labelPetinfo = cn(body({ size: "sm" }), "leading-5")
const indicator = cn("rounded-full w-2 h-2 group-aria-selected:bg-white")
const radioGroup = cn("flex flex-col gap-3")

export {
  indicator,
  indicatorVariants,
  label,
  labelPetinfo,
  radioCardCheckableVariants,
  radioCardVariants,
  radioGroup,
  root,
  wrapper,
}
